import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./errorPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function GeneralErrorPopup({
  onClose,
  text,
}: IPopupWithoutProps & { text?: string }) {
  return (
    <article className={popupStyles.popup}>
      <h2 className={popupStyles.popup__title}>
        {text || t('SOMETHING_WENT_WRONG')}
      </h2>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t('APPROVAL')}</button>
    </article>
  );
}

export default GeneralErrorPopup;
